import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { situations } from '../data/framework';
export function Situations() {
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-334" data-mp="ry2n6r5pg6er">
      <div className="mx-auto max-w-5xl" data-id="element-335" data-mp="rwjatbn66fi9">
        <SectionHeading eyebrow="Is This for You?" title="Do Any of These Situations Sound Familiar?" intro="If you recognize even one of these situations, I created Perio Blueprint™ with you in mind." data-id="element-336" data-mp="vzxp9xvgmntl" />

        <div className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-337" data-mp="15w12byruo6vb">
          {situations.map((s, i) => <div key={s.title} className="flex gap-4 border-t border-brand/10 pt-6" data-id="element-338" data-mp="1ap3v44oszcag" data-mpi={i}>
              <span className="font-serif text-4xl font-black leading-none text-brand/25" data-id="element-339" data-mp="1fmvq57kqveiv">{i + 1}</span>
              <div data-id="element-340" data-mp="1jql83e6wyxux">
                <h3 className="text-lg font-extrabold leading-snug text-ink sm:text-xl" data-id="element-341" data-mp="1jn5t0bd8poti">{s.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-342" data-mp="1olqt8ashs8hy">{s.text}</p>
              </div>
            </div>)}
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-343" data-mp="3hf9o0jr13ina">
          <p data-id="element-344" data-mp="3chrmvfj967pu">And that’s exactly why I built Perio Blueprint™.</p>
          <p data-id="element-345" data-mp="37iychvz9iwtw">The problem isn’t always a lack of information.</p>
          <p className="font-serif text-2xl font-bold text-brand-dark" data-id="element-346" data-mp="90javcb7i231">
            Sometimes, it’s the lack of a clear structure for organizing the information you already have.
          </p>
        </div>

        <div className="mt-10" data-id="element-347" data-mp="3vg3xl5ptbpnj">
          <CTAButton label="I Want a Structured Periodontal Framework" data-id="element-348" data-mp="3vf2d6amwpqt5" />
        </div>
      </div>
    </section>;
}